import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { finalize, tap } from 'rxjs/operators';
import { LoggerService } from '../utility-services/logger.service';

@Injectable()
export class SpHttpLogInterceptor implements HttpInterceptor {
  constructor(private loggerService: LoggerService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const startTime = Date.now();
    let status: string;

    return next.handle(req).pipe(
      tap(
        event => {
          status = '';
          if (event instanceof HttpResponse) {
            status = 'succeeded';
          }
        },
        error => {
          status = 'failed';
          this.loggerService.error(error);
        }
      ),
      finalize(() => {
        const elapsedTime = Date.now() - startTime;
        const message =
          req.method + ' ' + req.urlWithParams + ' ' + status + ' in ' + elapsedTime + 'ms';

        this.loggerService.info(message);
      })
    );
  }
}
